import React, { useState } from 'react'
import InputMask from 'react-input-mask'

// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
export const PhoneInput = (props: any): JSX.Element => {
  const [value, setValue] = useState<string>('')

  const handleChange = (value: React.ChangeEvent<HTMLInputElement>) => {
    setValue(value.target.value)
  }
  return (
    <InputMask
      mask='999-999-9999'
      onChange={handleChange}
      value={value}
      {...props}
    />
  )
}
